
import React from 'react';
import { TrustBadge } from './HeroTypes';

interface HeroTrustBadgesProps {
  trustBadges?: TrustBadge[];
}

const HeroTrustBadges: React.FC<HeroTrustBadgesProps> = ({ trustBadges = [] }) => {
  const defaultBadges = [
    { text: 'The Guardian', icon: null },
    { text: 'NBC', icon: null },
    { text: "Fodor's Travel", icon: null },
    { text: 'Time Out', icon: null },
  ];

  const badgesToShow = trustBadges.length > 0 ? trustBadges : defaultBadges;
  
  return (
    <div className="mt-10 pt-4">
      <p className="text-white/90 font-montserrat mb-2 text-shadow-sm">Trusted by Cat Lovers Worldwide</p>
      <div className="flex flex-wrap justify-start items-center gap-4 mt-2">
        {badgesToShow.map((badge, index) => (
          <span key={index} className="bg-white/70 backdrop-blur-sm px-3 py-1 rounded text-[#3E2723] text-sm">
            {badge.icon && <span className="mr-2">{badge.icon}</span>}
            {badge.text}
          </span>
        ))}
      </div>
    </div>
  );
};

export default HeroTrustBadges;
